import { Input, Button, Space, Tag } from 'antd';
import { SearchOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import _ from 'lodash';

export const SharedTableConfig = (handleSearch, handleReset, editDedicated, responsibilities) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
                backgroundColor: '#32d193',
                borderColor: '#32d193',
                color: 'white',
              }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'Name',
      dataIndex: 'client_name',
      key: 'client_name',
      width: '3%',
      ...getColumnSearchProps('client_name'),
    },
    {
      title: 'Plan',
      dataIndex: 'cplan',
      key: 'cplan',
      width: '3%',
    },
    {
      title: 'Domain',
      dataIndex: 'cdomain',
      key: 'cdomain',
      width: '3%',
    },
    {
      title: 'Email',
      dataIndex: 'cemail',
      key: 'cemail',
      width: '5%',
    },
    {
      title: 'User',
      dataIndex: 'username',
      key: 'username',
      width: '3%',
    },
    {
      title: 'Password',
      dataIndex: 'password',
      key: 'password',
      width: '3%',
    },
    {
      title: 'Created',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '3%',
      render: (created_at) => {
        return <div>{created_at ? created_at.split('T')[0] : 'N/A'}</div>;
      },
    },
    {
      title: 'Cancel',
      dataIndex: 'iscancel',
      key: 'iscancel',
      width: '3%',
      render: (iscancel) => {
        return <Tag color={iscancel ? 'green' : 'red'}>{iscancel ? 'Active' : 'In Active'}</Tag>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'isactive',
      key: 'isactive',
      width: '3%',
      render: (status) => {
        return <Tag color={status ? 'green' : 'red'}>{status ? 'Active' : 'In Active'}</Tag>;
      },
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: '2%',
      render: (item) => {
        return (
          <div>
            <Space size="middle">
              <EyeOutlined style={{ color: '#0D8616', cursor: 'pointer', fontSize: '20px' }} />
              {_.includes(responsibilities, 'EDIT_SHARED') ? (
                <EditOutlined
                  style={{ color: '#0D4B86', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => editDedicated(item)}
                />
              ) : (
                ''
              )}
              
            </Space>
          </div>
        );
      },
    },
  ];
};
